let dust = require('dustjs-helpers');
const dustExtensions = require('build-dust-extensions');
dust.templates = require('../lib/templates');
dust = dustExtensions.customHelpers.extend(dust);
dust = dustExtensions.customFilters.extend(dust);

module.exports = dust;
